import { deepMerge } from "./object-helper";
import { MeasurementSystem } from "../data/user-preferences";
import { EventCategory } from "../data/event";
export const defaultUserPreferences = {
    lastUpdated: "1970-01-01T00:00:00Z",
    measurementSystem: MeasurementSystem.Metric,
    alertsEventCategoryFilter: Object.values(EventCategory).sort(),
    eventsEventFilter: [
        "ACCELERATION",
        "TURNING",
        "BRAKING",
    ].sort(),
    eventsSpeedingVisibility: true,
    eventsSpeedingThreshold: 0,
    showWelcomeScreen: true,
    showFloorPlanOnboarding: true,
    showRulesEngine: false,
    language: null,
};
/**
 * Gets a complete user preference object,
 * with unspecified preferences substituted for defaults
 */
export function resolveDefaultUserPreferences(preferences) {
    return deepMerge(defaultUserPreferences, preferences);
}
//# sourceMappingURL=default-user-preferences.js.map